import type { ReactNode } from "react";

export function ServicePavilionFrame({ children }: { children: ReactNode }) {
  return <div className="service-pavilion-frame"><div className="pavilion-atmosphere" aria-hidden="true" />{children}</div>;
}
